import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Pagination,
  Spinner,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import Swal from "sweetalert2";
import QuestionCard from "./QuestionCard";

function PsikotesContent({
  handleSubmit,
  selectedOptions,
  handleOptionChange,
  questions,
  loading,
  currentPage,
  cardsPerPage,
  setCurrentPage,
  completedPages,
  setCompletedPages,
}) {
  const [currentPageCompleted, setCurrentPageCompleted] = useState(false);
  const [disabledPages, setDisabledPages] = useState([]);
  const [allQuestionsAnswered, setAllQuestionsAnswered] = useState(false);

  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  const currentCards = questions.slice(indexOfFirstCard, indexOfLastCard);

  useEffect(() => {
    const statementsPerPage = cardsPerPage * 2; // 1 card = 2 statements (1 yes + 1 no)
    const answeredStatements = Object.values(selectedOptions).filter(
      (option) =>
        option.questionIndex >= indexOfFirstCard &&
        option.questionIndex < indexOfLastCard
    ).length;

    const allAnswered = answeredStatements === statementsPerPage;
    setCurrentPageCompleted(allAnswered);

    if (allAnswered && !completedPages.includes(currentPage)) {
      setCompletedPages((prev) => [...prev, currentPage]);
    }

    if (currentPage > 1 && !disabledPages.includes(currentPage - 1)) {
      setDisabledPages((prev) => [...prev, currentPage - 1]);
    }

    const totalStatements = questions.length * 2;
    const totalAnswered = Object.values(selectedOptions).length;
    setAllQuestionsAnswered(totalAnswered === totalStatements);
  }, [
    selectedOptions,
    currentPage,
    indexOfFirstCard,
    indexOfLastCard,
    setCompletedPages,
    completedPages,
    disabledPages,
    questions.length,
    cardsPerPage,
  ]);

  const paginate = (pageNumber) => {
    if (
      pageNumber === currentPage + 1 &&
      currentPageCompleted &&
      !completedPages.includes(pageNumber)
    ) {
      Swal.fire({
        title: "Apakah Jawaban Anda Sudah Sesuai?",
        text: "Anda tidak dapat kembali ke halaman sebelumnya setelah melanjutkan.",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Batal",
        confirmButtonText: "Ya, lanjutkan",
      }).then((result) => {
        if (result.isConfirmed) {
          setCurrentPage(pageNumber);
          setTimeout(() => {
            window.scrollTo({ top: -100, behavior: "smooth" });
          }, 300);
        }
      });
    } else {
      setCurrentPage(pageNumber);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const renderPagination = () =>
    Array.from({ length: Math.ceil(questions.length / cardsPerPage) }).map(
      (_, index) => {
        const isDisabled =
          !(
            completedPages.includes(index + 1) ||
            index + 1 === currentPage ||
            (index + 1 === currentPage + 1 && currentPageCompleted) ||
            index + 1 === currentPage - 1
          ) || disabledPages.includes(index + 1);

        return (
          <OverlayTrigger
            key={index}
            placement="top"
            overlay={
              isDisabled ? (
                <Tooltip
                  id={`tooltip-${index}`}
                  className="custom-tooltip-paginate"
                >
                  Harap isi semua pernyataan di atas sebelum melanjutkan ke
                  halaman berikutnya
                </Tooltip>
              ) : (
                <></>
              )
            }
            rootClose={false}
          >
            <span
              className="d-inline-block"
              style={{ cursor: isDisabled ? "pointer" : "default" }}
            >
              <Pagination.Item
                active={index + 1 === currentPage}
                disabled={isDisabled}
                onClick={() => !isDisabled && paginate(index + 1)}
                style={{ pointerEvents: isDisabled ? "none" : "auto" }}
              >
                {index + 1}
              </Pagination.Item>
            </span>
          </OverlayTrigger>
        );
      }
    );

  return (
    <>
      <Row className="d-flex justify-content-center">
        {loading ? (
          <Col md={12} className="text-center">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading</span>
            </Spinner>
          </Col>
        ) : questions.length > 0 ? (
          currentCards.map((question, index) => (
            <Col md={4} sm={6} className="mb-4" key={index}>
              <QuestionCard
                questionIndex={index + indexOfFirstCard}
                statements={question.statements}
                handleOptionChange={handleOptionChange}
                selectedOptions={selectedOptions}
              />
            </Col>
          ))
        ) : (
          <Col md={12} className="text-center">
            <p>No questions available.</p>
          </Col>
        )}
      </Row>
      {!loading && questions.length > 0 && (
        <Row className="d-flex justify-content-center align-items-center text-center">
          <Col
            md={12}
            className="d-flex justify-content-center align-items-center text-center"
          >
            <Pagination>{renderPagination()}</Pagination>
          </Col>
          {currentPage === Math.ceil(questions.length / cardsPerPage) && (
            <Col md={12} className="mt-2 mb-4">
              <Button
                className="btn-simpan-test"
                onClick={handleSubmit}
                disabled={!allQuestionsAnswered}
                style={{
                  backgroundColor: !allQuestionsAnswered ? "grey" : null,
                }}
              >
                Submit
              </Button>
            </Col>
          )}
        </Row>
      )}
    </>
  );
}

export default PsikotesContent;
